module.exports = __webpack_public_path__ + "974ed91723371d09925d0d3d00de7fa2.MP3";